import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useState } from "react";
import { AddDateStampModal } from "./AddDateStampModal";
import { useTranslation } from "@coworker/locales";

export const DateStamp = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [dateStamp, setDateStamp] = useState<string>("");

  const handleSubmit = (newDateStamp: string) => {
    setDateStamp(newDateStamp);
    setShowModal(false);
  };

  return (
    <>
      <FixaListViewItem
        size="medium"
        control="navigational"
        controlIcon="chevronRight"
        inset
        onClick={() => setShowModal(true)}
        id="date-stamp"
        data-testid="date-stamp-item"
        title={
          <FixaText textStyle="Heading.XS">{t("dateStampString")}</FixaText>
        }
        description={dateStamp}
      ></FixaListViewItem>
      <AddDateStampModal
        showModal={showModal}
        handleClose={() => setShowModal(false)}
        dateStamp={dateStamp}
        onSubmit={handleSubmit}
      />
    </>
  );
};
